import { GRAPH_URL } from "../../../constants";

const query = `
    query userCountry {
        userCountry {
          code
          name
        }
    }
`;

const getUserCountry = () =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) {
        const message = res.errors[0].message;
        const error = new Error(message);
        error.name = res.errors[0].name;
        throw error;
      }
      return res;
    });

export default getUserCountry;
